// Shared by employee cards, request forms and server validation.
const PPE_SIZE_LIMIT = 50;
const PPE_NOTES_LIMIT = 1000;
const PPE_FORM_FIELDS = Object.freeze([
    {key: 'jacket', label: 'Размер куртки', shortLabel: 'Куртка', example: '52–54 или XL'},
    {key: 'trousers', label: 'Размер брюк', shortLabel: 'Брюки', example: '52–54 или XL'},
    {key: 'height', label: 'Рост / ростовка', shortLabel: 'Рост / ростовка', example: '182 или 182–188'},
    {key: 'shoes', label: 'Размер обуви', shortLabel: 'Обувь', example: '43'},
    {key: 'gloves', label: 'Размер перчаток', shortLabel: 'Перчатки', example: '10 или XL'},
    {key: 'headwear', label: 'Размер головного убора', shortLabel: 'Головной убор', example: '58'},
    {key: 'notes', label: 'Примечание'}
].map(field => Object.freeze({...field, limit: field.key === 'notes' ? PPE_NOTES_LIMIT : PPE_SIZE_LIMIT})));
const PPE_FIELDS = Object.freeze(Object.fromEntries(PPE_FORM_FIELDS.map(field => [field.key, field.label])));
const SIZE_LABELS = Object.freeze(Object.fromEntries(PPE_FORM_FIELDS.filter(field => field.key !== 'notes').map(field => [field.key, field.shortLabel])));

module.exports = {PPE_FORM_FIELDS, PPE_FIELDS, SIZE_LABELS, PPE_SIZE_LIMIT, PPE_NOTES_LIMIT};
